var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "energy-label"
  }, [(_vm.labelImage) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs.modal.show()
      }
    }
  }, [_c('energy-efficiency-class', {
    attrs: {
      "value": _vm.efficiencyClass
    }
  })], 1) : _c('energy-efficiency-class', {
    attrs: {
      "value": _vm.efficiencyClass
    }
  }), _vm._v(" "), (_vm.labelImage) ? _c('modal', {
    ref: "modal",
    attrs: {
      "playground": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-body"
  }, [_c('img', {
    staticClass: "energy-label__image",
    attrs: {
      "src": _vm.labelImage.url
    }
  })])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea4b9a1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/EnergyLabel.vue
// module id = 1947
// module chunks = 0